import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import {
  BaseCoreState,
  BaseDateService,
  BaseInquiryShiftsWithFlex,
  BaseShiftIconsWithFlex,
  baseInquirySelectors,
  ShiftPlanCalendarDateInterface,
  ShiftPlanListBubbleItemInterface,
} from 'base';
import {
  ShiftPlanMdBubbleClickInterface,
  ShiftPlanMdColumnInterface,
  ShiftPlanMdGutterGroupInterface,
} from '../../../../_interfaces/base-customer-shift-plan-md.interface';
import { buildShiftPlanMdGutterGroups } from '../../../../_helpers/base-customer-shift-plan-md-gutter.helper';

@Component({
  selector: 'base-customer-shift-plan-md-organizer',
  templateUrl: './base-customer-shift-plan-md-organizer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseCustomerShiftPlanMdOrganizerComponent implements OnInit, OnDestroy {
  @Output() editShiftTimes = new EventEmitter<void>();
  @Output() showInquiryInfo = new EventEmitter<void>();
  @Output() bubbleClick = new EventEmitter<ShiftPlanMdBubbleClickInterface>();

  /**
   * Derived from BaseInquiryShiftsWithFlex so the header stays aligned with the bubble
   * order produced by BaseShiftPlanService.calculateBubbles(), which iterates the same enum.
   */
  readonly columns: ShiftPlanMdColumnInterface[] = Object.values(BaseInquiryShiftsWithFlex).map((shift) => ({
    shift,
    labelKey: shift === BaseInquiryShiftsWithFlex.flex ? 'inquiry.flexibleShifts' : `shiftTimes.label.${shift}`,
    icon: shift === BaseInquiryShiftsWithFlex.flex ? '' : BaseShiftIconsWithFlex[shift],
  }));

  days: ShiftPlanCalendarDateInterface[] = [];
  monthGroups: ShiftPlanMdGutterGroupInterface[] = [];
  weekGroups: ShiftPlanMdGutterGroupInterface[] = [];

  private destroy$ = new Subject<void>();

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit(): void {
    this.store
      .select(baseInquirySelectors.getShiftPlanList)
      .pipe(
        takeUntil(this.destroy$),
        map((data) => data.list as ShiftPlanCalendarDateInterface[])
      )
      .subscribe((days) => {
        this.days = days;
        this.monthGroups = buildShiftPlanMdGutterGroups(days, ({ dateItem }) => dateItem.monthLong);
        this.weekGroups = buildShiftPlanMdGutterGroups(
          days,
          ({ dateItem }) => `CW${BaseDateService.weekNumber(dateItem.dateString)}`
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackByColumn(_: number, item: ShiftPlanMdColumnInterface): string {
    return item.shift;
  }

  trackByGroup(_: number, item: ShiftPlanMdGutterGroupInterface): string {
    return item.gridRow;
  }

  trackByDay(_: number, item: ShiftPlanCalendarDateInterface): string {
    return item.dateItem.dateString;
  }

  trackByBubble(_: number, item: ShiftPlanListBubbleItemInterface): string {
    return item.shift;
  }
}
